var React = require('react');

function T3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"T3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"45.85 5.55 24.57 2.8 2.96 0 0 22.88 20.81 25.57 43.7 28.54 64.51 31.23 67.47 8.35 45.85 5.55","fill":"#e5c83d","key":0}),React.createElement("g",{"style":{"mixBlendMode":"multiply"},"key":1},React.createElement("rect",{"x":"19.76","y":"22.67","width":"23.07","height":"62.88","transform":"translate(6.28 -3.18) rotate(6.46)","fill":"#f47643"}))])]);
}

T3.defaultProps = {"viewBox":"0 0 67.47 86.65"};

module.exports = T3;

T3.default = T3;
